<template>
  <div class="contact-page page-wrapper">
    <div class="page-header">
      <div class="container">
        <h1 class="page-title">联系我们</h1>
        <p class="page-subtitle">Contact Us</p>
      </div>
    </div>

    <div class="page-content">
      <div class="container">
        <!-- 联系信息卡片 -->
        <div class="contact-cards" v-loading="loading">
          <div class="contact-card" v-for="(contact, index) in contacts" :key="contact.id">
            <div class="card-icon">
              <i class="el-icon-s-help"></i>
            </div>
            <div class="card-content">
              <p class="contact-name">{{ contact.name }}</p>
              <div class="contact-info">
                <p><i class="el-icon-phone"></i> {{ contact.phone }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- 会务组信息 -->
        <!-- <div class="org-info" v-loading="conferenceLoading">
          <div class="org-card" v-if="conferenceInfo">
            <h3><i class="el-icon-office-building"></i> 会务组信息</h3>
            <div class="org-content">
              <div class="org-item" v-if="conferenceInfo.organizer">
                <label>主办单位</label>
                <span>{{ conferenceInfo.organizer }}</span>
              </div>
              <div class="org-item" v-if="conferenceInfo.address">
                <label>会议地址</label>
                <span>{{ conferenceInfo.address }}</span>
              </div>
              <div class="org-item" v-if="conferenceInfo.start_time && conferenceInfo.end_time">
                <label>会议时间</label>
                <span>{{ conferenceInfo.start_time }} 至 {{ conferenceInfo.end_time }}</span>
              </div>
              <div class="org-item" v-if="conferenceInfo.venue">
                <label>会议地点</label>
                <span>{{ conferenceInfo.venue }}</span>
              </div>
            </div>
          </div>
        </div> -->

        <!-- 在线留言 -->
        <!-- <div class="message-section">
          <h2 class="section-title">在线留言</h2>
          <p class="section-desc">如有任何问题，欢迎给我们留言，我们会尽快回复</p>
          
          <el-form 
            ref="messageForm" 
            :model="messageForm" 
            :rules="messageRules"
            label-width="80px"
            class="message-form"
          >
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="姓名" prop="name">
                  <el-input v-model="messageForm.name" placeholder="请输入您的姓名"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="邮箱" prop="email">
                  <el-input v-model="messageForm.email" placeholder="请输入您的邮箱"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="电话" prop="phone">
                  <el-input v-model="messageForm.phone" placeholder="请输入您的联系电话"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="主题" prop="subject">
                  <el-select v-model="messageForm.subject" placeholder="请选择咨询主题" style="width: 100%">
                    <el-option label="报名咨询" value="registration"></el-option>
                    <el-option label="摘要投稿" value="paper"></el-option>
                    <el-option label="住宿交通" value="accommodation"></el-option>
                    <el-option label="其他问题" value="other"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="留言内容" prop="content">
              <el-input 
                type="textarea" 
                v-model="messageForm.content" 
                placeholder="请输入您的留言内容"
                :rows="5"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" :loading="submitting" @click="submitMessage">
                提交留言
              </el-button>
              <el-button @click="resetForm">重置</el-button>
            </el-form-item>
          </el-form>
        </div> -->

        <!-- 常见问题 -->
        <!-- <div class="faq-section">
          <h2 class="section-title">常见问题</h2>
          <el-collapse v-model="activeFaq" accordion>
            <el-collapse-item v-for="(faq, index) in faqs" :key="index" :name="index">
              <template slot="title">
                <span class="faq-question">{{ faq.question }}</span>
              </template>
              <div class="faq-answer">{{ faq.answer }}</div>
            </el-collapse-item>
          </el-collapse>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { contactApi, conferenceApi } from '@/api'

export default {
  name: 'Contact',
  data() {
    return {
      loading: false,
      conferenceLoading: false,
      contacts: [],
      conferenceInfo: null,
      submitting: false,
      activeFaq: 0,
      messageForm: {
        name: '',
        email: '',
        phone: '',
        subject: '',
        content: ''
      },
      messageRules: {
        name: [
          { required: true, message: '请输入您的姓名', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入您的邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
        ],
        subject: [
          { required: true, message: '请选择咨询主题', trigger: 'change' }
        ],
        content: [
          { required: true, message: '请输入留言内容', trigger: 'blur' },
          { min: 10, message: '留言内容不少于10个字符', trigger: 'blur' }
        ]
      },
      faqs: [
        {
          question: '如何报名参加会议？',
          answer: '您可以通过本网站的"报名缴费"页面进行在线报名。注册账号后，填写个人信息并完成支付即可。如有问题，可联系报名咨询张老师。'
        },
        {
          question: '会议费用包含哪些内容？',
          answer: '会议费用包含：全程参会资格、会议资料包、茶歇及午餐、欢迎晚宴、电子证书。住宿费用需自理，我们可协助预订协议价酒店。'
        },
        {
          question: '摘要投稿有什么要求？',
          answer: '摘要应为未公开发表的原创研究成果，格式请参照大会提供的模板。文件格式支持PDF或Word，大小不超过20MB，篇幅控制在6-12页。'
        },
        {
          question: '如何获取发票？',
          answer: '完成支付后，可在个人中心申请电子发票。如需纸质发票，请联系会务组。发票将在会议结束后15个工作日内开具。'
        },
        {
          question: '取消报名可以退款吗？',
          answer: '2025年2月28日前取消报名，可全额退款；2025年3月1日至3月10日取消，退还50%费用；3月10日后取消，不予退款。'
        },
        {
          question: '现场如何签到？',
          answer: '请于会议当天8:00-8:30携带身份证件到一层大厅签到处办理签到，领取会议资料包和参会证。'
        }
      ],
      iconClasses: ['el-icon-user', 'el-icon-document', 'el-icon-s-help', 'el-icon-phone-outline', 'el-icon-service', 'el-icon-chat-dot-round']
    }
  },
  created() {
    this.fetchContacts()
    this.fetchConferenceInfo()
  },
  methods: {
    // 获取联系信息
    async fetchContacts() {
      this.loading = true
      try {
        const res = await contactApi.getList(1)
        this.contacts = res.data || []
      } catch (error) {
        console.error('获取联系信息失败', error)
        this.$message.error('获取联系信息失败')
      } finally {
        this.loading = false
      }
    },
    // 获取会议信息
    async fetchConferenceInfo() {
      this.conferenceLoading = true
      try {
        const res = await conferenceApi.getDetail(1)
        this.conferenceInfo = res.data || null
      } catch (error) {
        console.error('获取会议信息失败', error)
        this.$message.error('获取会议信息失败')
      } finally {
        this.conferenceLoading = false
      }
    },
    // 根据索引获取图标类名
    getIconClass(index) {
      return this.iconClasses[index % this.iconClasses.length]
    },
    submitMessage() {
      this.$refs.messageForm.validate((valid) => {
        if (!valid) return

        this.submitting = true
        
        // 模拟提交
        setTimeout(() => {
          this.submitting = false
          this.$message.success('留言提交成功，我们会尽快回复您')
          this.resetForm()
        }, 1500)
      })
    },
    resetForm() {
      this.$refs.messageForm.resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.contact-page {
  background: #f8f9fc;
}

.contact-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-bottom: 50px;
}

.contact-card {
  background: #fff;
  border-radius: 16px;
  padding: 40px 30px;
  text-align: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.3s;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 20px 40px rgba(26, 35, 126, 0.15);

    .card-icon {
      background: linear-gradient(135deg, #1a237e 0%, #7c4dff 100%);
      
      i {
        color: #fff;
      }
    }
  }

  .card-icon {
    width: 80px;
    height: 80px;
    background: #f0f2f8;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 24px;
    transition: all 0.3s;

    i {
      font-size: 36px;
      color: #1a237e;
    }
  }

  .card-title {
    font-size: 22px;
    font-weight: 600;
    color: #1a237e;
    margin-bottom: 20px;
  }

  .contact-name {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin-bottom: 16px;
  }

  .contact-info {
    margin-bottom: 16px;

    p {
      font-size: 14px;
      color: #555;
      margin: 10px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;

      i {
        color: #7c4dff;
      }
    }
  }

  .contact-desc {
    font-size: 13px;
    color: #999;
    line-height: 1.6;
  }
}

.org-info {
  margin-bottom: 50px;
}

.org-card {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);

  h3 {
    background: linear-gradient(135deg, #1a237e 0%, #3949ab 100%);
    color: #fff;
    padding: 20px 30px;
    font-size: 20px;
    display: flex;
    align-items: center;
    gap: 12px;

    i {
      color: #ffd700;
    }
  }

  .org-content {
    padding: 30px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  .org-item {
    display: flex;
    align-items: flex-start;
    gap: 16px;

    label {
      min-width: 80px;
      font-size: 14px;
      color: #999;
    }

    span {
      font-size: 15px;
      color: #333;
    }
  }
}

.section-title {
  font-size: 24px;
  font-weight: 600;
  color: #1a237e;
  margin-bottom: 10px;
  text-align: center;
}

.section-desc {
  text-align: center;
  color: #666;
  margin-bottom: 30px;
}

.message-section {
  background: #fff;
  border-radius: 16px;
  padding: 40px;
  margin-bottom: 50px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.message-form {
  max-width: 800px;
  margin: 0 auto;
}

.faq-section {
  background: #fff;
  border-radius: 16px;
  padding: 40px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);

  .el-collapse {
    border: none;
  }

  ::v-deep .el-collapse-item__header {
    height: auto;
    padding: 20px 0;
    font-size: 16px;
    border-bottom: 1px solid #f0f0f0;
  }

  ::v-deep .el-collapse-item__content {
    padding-bottom: 20px;
  }

  .faq-question {
    font-weight: 500;
    color: #1a237e;
  }

  .faq-answer {
    font-size: 14px;
    color: #666;
    line-height: 1.8;
  }
}

@media screen and (max-width: 992px) {
  .contact-cards {
    grid-template-columns: 1fr;
  }

  .org-card .org-content {
    grid-template-columns: 1fr;
  }
}

@media screen and (max-width: 576px) {
  .message-section,
  .faq-section {
    padding: 24px;
  }

  .message-form .el-col {
    width: 100%;
  }
}
</style>
